import React from "react";

/**
 * TextArea Component
 *
 * Reusable textarea field with label, optional helper text, and consistent styling.
 *
 * @param {string} label - Label text to display above the textarea
 * @param {string} value - Current textarea value
 * @param {function} onChange - Handler for value changes
 * @param {string} placeholder - Placeholder text
 * @param {number} rows - Number of rows (default: 4)
 * @param {string} helperText - Optional helper text below label
 * @param {boolean} optional - Whether to show "(optional)" in label
 */
const TextArea = ({
  label,
  value,
  onChange,
  placeholder = "",
  rows = 4,
  helperText,
  optional = false,
}) => {
  return (
    <div>
      {label && (
        <label
          style={{
            display: "block",
            fontSize: "14px",
            fontWeight: "500",
            color: "#525252",
            marginBottom: "8px",
          }}
        >
          {label}{" "}
          {optional && (
            <span style={{ color: "#a3a3a3", fontWeight: "400" }}>
              (optional)
            </span>
          )}
        </label>
      )}
      {helperText && (
        <p
          style={{
            fontSize: "13px",
            color: "#737373",
            margin: "0 0 8px 0",
          }}
        >
          {helperText}
        </p>
      )}
      <textarea
        value={value}
        onChange={onChange}
        rows={rows}
        placeholder={placeholder}
        style={{
          width: "100%",
          padding: "12px 16px",
          fontSize: "15px",
          color: "#1a1a1a",
          backgroundColor: "#fff",
          border: "1px solid #e5e5e5",
          borderRadius: "8px",
          outline: "none",
          transition: "border-color 0.2s ease",
          boxSizing: "border-box",
          fontFamily: "inherit",
          resize: "vertical",
        }}
        onFocus={(e) => (e.currentTarget.style.borderColor = "#a3a3a3")}
        onBlur={(e) => (e.currentTarget.style.borderColor = "#e5e5e5")}
      />
    </div>
  );
};

export default TextArea;
